import React from 'react'
import { IUser } from 'app/models/user'
import { createContext, useContext} from 'react'

import { useUserContext } from './user-context'

export interface IRequireUserContext {
    currentUser: IUser
    reloadCurrentUser: () => Promise<void>
}

const RequireUserContext = createContext<IRequireUserContext>({} as IRequireUserContext)

export const useRequireUserContext = () => useContext(RequireUserContext)

export const RequireUserContextProvider: React.FC = ({ children }) => {
    const userContext = useUserContext()
    if (!userContext) {
        return <></>
    }

    const { currentUser, reloadCurrentUser } = userContext

    if(!currentUser) {
        return <></>
    }

    return (
        <RequireUserContext.Provider value={{ currentUser, reloadCurrentUser }}>
            {children}
        </RequireUserContext.Provider>
    )
}
